import Vue from 'vue'
import store from '../stores/store'

// Filtre de formattage d'une date en français
Vue.filter('frenchDate', function (value) {
    let date = moment(value).format('DD/MM/Y')
    return date === 'Invalid date' ? '' : date
})

// Filtre de formattage de la date de cloture
Vue.filter('dateCloture', function (value) {
    let date = moment(value).format('DD/MM')
    return date === 'Invalid date' ? '' : date
})

// Filtre de formattage d'une date en français
Vue.filter('frenchDateTime', function (value) {
    let date = moment(value).format('DD/MM/Y HH:mm')
    return date === 'Invalid date' ? '' : date
})

// Filtre de formattage de mise au pluriel d'un mot
Vue.filter('plural', function (value, count) {
    return count > 1 ? value + 's' : value
})

// Filtre de formattage de mise en pourcentage
Vue.filter('percent', function (value, count) {
    return (Math.round(value * 10000 / count) / 100 || 0) + '%'
})

// Filtre de formattage de mise en euros
Vue.filter('euros', function (value) {
    return (Math.round(value * 100) / 100 || 0) + ' €'
})

// Filtre de formattage Oui / Non
Vue.filter('yesNo', function (value) {
    if (value === undefined || value === null)
        return ''

    return value === true || parseInt(value) ? 'Oui': 'Non'
})

// Filtre de GedType
Vue.filter('gedTypeLibelle', function (id) {
    if(!store.getters.optionsGedTypes.length){
        return null
    }
    return (store.getters.optionsGedTypes.find(({value}) => value === id)).label
})

// Filtre libellé Retro
Vue.filter('retroLibelle', function (id) {
    if (id === undefined || id === null)
        return ''

    return (store.getters.optionsRetro.find(({value}) => value.toString() === id.toString())).label
})
